import { render, staticRenderFns } from "./abroadlogistics-edit.vue?vue&type=template&id=c371912a"
import script from "./abroadlogistics-edit.vue?vue&type=script&lang=ts"
export * from "./abroadlogistics-edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports